import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default class ScrollMoment extends HTMLElement {

	constructor() {
		super();
		this.wrapper = this.querySelector(".scroll-moment-wrapper")
		this.init();
	}

	init() {
		if (!this.wrapper) return;

		let scrollTl = gsap.timeline({
			scrollTrigger: {
				trigger: this.wrapper,

				//Pinned scroll scene:
				pin: true,
				start: "top top", // IF PINNED!
				end: "+=200%",

				scrub: true, // smooth scrubbing, boolean or int representing "catch-up" time
			}
		});

		scrollTl
			.to(this.querySelector(".slide1"), {
				yPercent: -120,
				opacity: 0,
				duration: 15,
			}, 25)
		scrollTl
			.fromTo(this.querySelector(".slide2"), {
				yPercent: 120,
				opacity: 0,
			}, {
				yPercent: 0,
				opacity: 1,
				duration: 15,
				// onStart: () => {
				// 	this.animateValue(
				// 		this.querySelector(".count-up"),
				// 		0,
				// 		this.querySelector(".count-up")?.textContent,
				// 		1200
				// 	);
				// }
			}, 25,)
	}

	// animateValue(el, start, end, duration) {
	// 	let startTimestamp = null;
	// 	const step = (timestamp) => {
	// 		if (!startTimestamp) startTimestamp = timestamp;
	// 		const progress = Math.min((timestamp - startTimestamp) / duration, 1);
	// 		const count = Math.floor(progress * (end - start) + start)
	// 		el.innerHTML = count < 10 ? `0${count}` : count
	// 		if (progress < 1) {
	// 			window.requestAnimationFrame(step);
	// 		}
	// 	};
	// 	window.requestAnimationFrame(step);
	// }
}
